






























import Vue from 'vue'
import _ from 'lodash'
import moment from 'moment'
import { AbsencesFilterScope, SecurityArea, SecurityComponent } from '@/types/enums'
import { PlannedShift } from '@/model/planning/PlannedShift'
import { ABSENCES_ASSISTANT_GET_CURRENT_ABSENCE } from '@/store/getter-types'
import { ABSENCES_ASSISTANT_SET_CURRENT_ABSENCE } from '@/store/action-types'
import { Absence } from '@/model/absences/Absence'
import { CheckedAbsenceList } from '@/types'
import * as securityService from '@/services/security-service'

interface ComponentData {
  currentAbsence: any
  displaySearchMenu: boolean
  showDrawer: boolean
  filterScope: AbsencesFilterScope
  filterSearchString: string | null
  showSearch: boolean
  displayAbsenceList: Array<CheckedAbsenceList>
  isFilterActive: boolean
  checkedList: Array<CheckedAbsenceList>
  isCheckedAll: boolean
}

export default Vue.extend({
  name: 'AbsenceList',

  props: {
    drawer: Boolean,
    absenceList: {
      type: Array as () => Array<Absence>
    },
    selectedAbsence: Object as () => any,
    resetSearchFilter: Boolean,
    unselect: Boolean,
    toolbarFilterScope: Number,
    toolbarFilterSearchString: String
  },

  data (): ComponentData {
    return {
      currentAbsence: undefined,
      showDrawer: false,
      displaySearchMenu: false,
      filterScope: AbsencesFilterScope.AllAbsences,
      filterSearchString: null,
      showSearch: false,
      displayAbsenceList: [],
      isFilterActive: false,
      checkedList: [],
      isCheckedAll: false,
    }
  },

  computed: {
    currentAbsenceStore (): PlannedShift | undefined {
      return this.$store.getters[ABSENCES_ASSISTANT_GET_CURRENT_ABSENCE]
    },

    showToolbarFunctions (): boolean {
      return securityService.isVisible(SecurityArea.Absences, SecurityComponent.ToolbarFunctions)
    },

    filteredAbsenceList (): CheckedAbsenceList[] {
      return this.displayAbsenceList.filter((item: CheckedAbsenceList) => item.show)
    }
  },

  watch: {
    unselect (newVal: boolean): void {
      if (newVal) {
        this.isCheckedAll = false
        this.displayAbsenceList.forEach((item: CheckedAbsenceList) => {
          item.isChecked = false
        })
        this.checkedList = []
        this.currentAbsence = undefined
        this.$emit('absenceSelected', this.currentAbsence)
      }
    },

    absenceList (newVal: Array<Absence>): void {
      if(newVal) {
        let list: any = _.cloneDeep(newVal)
        list.forEach((item: any) => {
          item.isChecked = false
        })
        this.displayAbsenceList = list
        this.filterAbsencesList()
      }
    },

    drawer (newVal: boolean): void {
      this.showDrawer = newVal
    },

    showDrawer (newVal: boolean): void {
      if(!newVal) {
        this.$emit('closeAbsenceDrawer')
      }
    },

    filterScope (newVal): void {
      this.filterAbsencesList()
      this.displaySearchMenu = false
      if (newVal === AbsencesFilterScope.AllAbsences) {
        if (this.filterSearchString && this.filterSearchString.length > 0) {
          this.isFilterActive = true
        } else {
          this.isFilterActive = false
          this.$emit('updateEventList')
        }
      } else {
        this.isFilterActive = true
        this.$emit('filteredAbsencesList', this.displayAbsenceList)
      }
    },

    selectedAbsence (newVal: any): void {
      if (newVal) {
        this.isCheckedAll = false
        this.displayAbsenceList.forEach((item: CheckedAbsenceList) => {
          item.isChecked = false
        })
        this.checkedList = []
        if(newVal.serie) {
          this.currentAbsence = this.filteredAbsenceList.find((item: CheckedAbsenceList) => item.serieId === newVal.serie)
        } else {
          this.currentAbsence = this.displayAbsenceList.find((item: CheckedAbsenceList) => item.id === newVal.absenceId)
        }
        this.currentAbsence.isChecked = true
        this.$emit('absenceSelected', this.currentAbsence)
      } else {
        this.displayAbsenceList.forEach((item: CheckedAbsenceList) => {
          item.isChecked = false
        })

        if (this.checkedList.length > 1) {
          this.displayAbsenceList.forEach((item: CheckedAbsenceList) => {
            this.checkedList.forEach((i: CheckedAbsenceList) => {
              if (i.id === item.id) {
                item.isChecked = true
              }
            })
          })
        }
        this.currentAbsence = undefined
      }
    },

    filterSearchString (newVal: string | null): void {
      if (newVal && newVal.length > 0) {
        this.isFilterActive = true
        this.$emit('filteredAbsencesList', this.displayAbsenceList)
      } else {
        if (this.filterScope === AbsencesFilterScope.AllAbsences) {
          this.isFilterActive = false
          this.$emit('updateEventList')
        } else {
          this.$emit('filteredAbsencesList', this.displayAbsenceList)
        }
      }
    },

    resetSearchFilter (newVal: boolean): void {
      /*if (newVal) {
        if (this.showToolbarFunctions) {
          this.filterScope = AbsencesFilterScope.AllAbsences
          this.filterSearchString = null
          this.isFilterActive = false
        } else {
          this.isFilterActive = false
        }
      }*/
    },

    toolbarFilterScope (newVal: number): void {
      this.filterScope = newVal
    },

    toolbarFilterSearchString (newVal: string | null): void {
      this.filterSearchString = newVal
      this.filterAbsencesList()
    }
  },

  methods: {
    formattedTitle (item: Absence): string {
      const date: string =  moment(item.start).format('DD.MM.').toString()
      return `${date} ${item.basicName} ${item.employeeName}`
    },

    onAbsenceClick (item: CheckedAbsenceList): void {
      this.displayAbsenceList.forEach((i: CheckedAbsenceList) => {
        if (i.id === item.id) {
          if (item.isChecked) {
            i.isChecked = false
            this.onCheckboxChange(i)
          } else {
            i.isChecked = true
            this.onCheckboxChange(i)
          }
        }
      })
    },

    filterAbsencesList (): void {
      this.currentAbsence = undefined
      this.$emit('absenceSelected', undefined)

      const filterRules = {
        text: this.filterSearchString && this.filterSearchString.toLocaleLowerCase() || '',
        scope: this.filterScope
      }

      if (this.currentAbsenceStore) {
        this.currentAbsence = _.cloneDeep(this.currentAbsenceStore)
        this.$emit('absenceSelected', this.currentAbsence)
        this.$store.dispatch(ABSENCES_ASSISTANT_SET_CURRENT_ABSENCE, undefined)
      }

      let list: any = _.cloneDeep(this.absenceList.filter((i: Absence) => i.satisfiesConditions(filterRules)))
      list.forEach((item: any) => {
        item.isChecked = false
      })
      this.isCheckedAll = false
      this.checkedList = []
      this.displayAbsenceList = list
      this.$emit('filteredAbsencesList', this.displayAbsenceList)
    },

    onCheckboxChange (item: CheckedAbsenceList): void {
      this.checkedList = this.displayAbsenceList.filter((item: CheckedAbsenceList) => item.isChecked)
      this.currentAbsence = item

      if (this.checkedList.length < 1) {
        this.isCheckedAll = false
        this.$emit('absenceSelected', undefined)
        this.$emit('disableEdit', this.checkedList)
      } else if (this.checkedList.length === 1) {
        this.isCheckedAll = false
        this.$emit('absenceSelected', this.checkedList[0])
        this.$emit('disableEdit', this.checkedList)
      } else {
        this.isCheckedAll = false
        this.$emit('absenceSelected', undefined)
        this.$emit('disableEdit', this.checkedList)
      }
    },

    onSelectAllChange (item: boolean): void {
      if (item) {
        this.displayAbsenceList.forEach((item: CheckedAbsenceList) => {
          item.isChecked = true
        })
        this.checkedList = this.displayAbsenceList
        this.$emit('absenceSelected', undefined)
        this.$emit('disableEdit', this.checkedList)
      } else {
        this.displayAbsenceList.forEach((item: CheckedAbsenceList) => {
          item.isChecked = false
        })
        this.checkedList = []
        this.$emit('absenceSelected', undefined)
        this.$emit('disableEdit', this.checkedList)

      }
    },

    onSelectAllClick (): void {
      this.isCheckedAll = !this.isCheckedAll
      this.onSelectAllChange(this.isCheckedAll)
    },

  }

})
